import React, { FC, useContext, useState } from 'react';

import Breadcrumb, { BreadcrumbItem } from 'view/section/Breadcrumb/Breadcrumb';
import { H2 } from 'view/component/Tipografia/Texto';
import { Conteudo } from 'view/section/Conteudo/Conteudo';
import { OperacaoFormularioBusca } from 'service/restricao/OperacaoFormulario/OperacaoFormulario';
import { FormikDebug } from 'view/component/Formulario/FormikDebug';
import { Formulario } from 'view/component/Formulario/Formulario';
import { Input } from 'view/component/Input/Input';
import { Label } from 'view/component/Label/Label';
import { useRestricoesFormulario } from 'service/restricao/useRestricoesFormulario/useRestricoesFormulario';
import { RestricoesTesteFormulario } from 'business/formulario/RestricoesTesteFormulario';
import { Button } from 'antd';
import { Select } from 'view/component/Select/Select';
import { SelectOption } from 'view/component/Select/SelectItem';
import { CascaderField, No } from 'view/component/CascaderField/CascaderField';
import { ServidorField } from 'view/component/ServidorField/ServidorField';
import { UsuarioLogadoContext } from 'view/component/UsuarioLogadoContext/UsuarioLogadoContext';
import { Editor } from 'view/component/Editor/Editor';


export const TesteFormularioPage: FC<any> = () => {
  const restricoes = useRestricoesFormulario(RestricoesTesteFormulario);
  const [loading, setLoading] = useState(false);
  const toggle = () => setLoading(it => !it);
  const carregandoLegenda = (estado: boolean) => estado ? 'Carregando' : 'Não carregando';
  const usuarioLogado = useContext(UsuarioLogadoContext).usuarioLogado;

  const opcoes: SelectOption[] = [
    { 'value': 1, 'label': 'Maracanaú'},
    { 'value': 2, 'label': 'Juazeiro do Norte'},
    { 'value': 3, 'label': 'Fortaleza'},
    { 'value': 4, 'label': 'Eusébio'},
    { 'value': 5, 'label': 'Aquiraz'},
    { 'value': 6, 'label': 'Senador Pompeu'},
    { 'value': 7, 'label': 'Guaramiranga'},
    { 'value': 8, 'label': 'Pacatuba'},
    { 'value': 9, 'label': 'Itapipoca'},
    { 'value': 10, 'label': 'Crato'},
    { 'value': 11, 'label': 'Camocim'},
    { 'value': 12, 'label': 'Cedro'},
  ];

  const floresta: No[] = [
    {
      id: 1,
      nome: "Ceará",
      filhos: [
        {
          id: 1,
          nome: "Maracanaú",
        },
        {
          id: 2,
          nome: "Crato",
        },
        {
          id: 3,
          nome: "Cedro",
        }
      ]
    },
    {
      id: 4,
      nome: "Bahia",
      filhos: [
        {
          id: 5,
          nome: "Salvador",
        },
        {
          id: 6,
          nome: "Ilhéus",
        },
        {
          id: 7,
          nome: "Barreiras",
        }
      ]
    }
  ]
  
  const parametrosFormik = {
    initialValues: {
      inputSemRestricao: 'Texto exemplo',
      inputHidden: 'Texto exemplo',
      inputDisabled: 'Texto exemplo',
      inputReadOnly: 'Texto exemplo',
      inputReadOnlyVazio: '',
      inputClearable: 'Texto exemplo',
      inputIsMulti: 'Texto exemplo',

      selectSemRestricao: 5,
      selectHidden: 5,
      selectDisabled: 5,
      selectReadOnly: 5,
      selectReadOnlyVazio: undefined,
      selectClearable: 5,

      selectMultiSemRestricao: [5, 10],
      selectMultiHidden: [5, 10],
      selectMultiDisabled: [5, 10],
      selectMultiReadOnly: [5, 10],
      selectMultiReadOnlyVazio: undefined,
      selectMultiClearable: [5, 10],

      cascaderSemRestricao: 5,
      cascaderHidden: 5,
      cascaderDisabled: 5,
      cascaderReadOnly: 5,
      cascaderReadOnlyVazio: undefined,
      cascaderClearable: 5,

      servidorSemRestricao: usuarioLogado.idInstitucional,
      servidorHidden: usuarioLogado.idInstitucional,
      servidorDisabled: usuarioLogado.idInstitucional,
      servidorReadOnly: usuarioLogado.idInstitucional,
      servidorReadOnlyVazio: undefined,
      servidorClearable: usuarioLogado.idInstitucional,

      editorSemRestricao: "Algum texto aleatório em **markdown**",
      editorHidden: "Algum texto aleatório em **markdown**",
      editorDisabled: "Algum texto aleatório em **markdown**",
      editorReadOnly: "Algum texto aleatório em **markdown**",
      editorReadOnlyVazio: undefined,
      editorClearable: "Algum texto aleatório em **markdown**",
    },
    enableReinitialize: true,
  }

  return (
    <>
      <Breadcrumb>
        <BreadcrumbItem href="/">Início</BreadcrumbItem>
        <BreadcrumbItem>Sobre</BreadcrumbItem>
      </Breadcrumb>

      <Conteudo>
        <H2>Formulário de testes</H2>

        <Formulario
          formik={parametrosFormik}
          carregando={loading}
          restricoes={restricoes}
          operacao={OperacaoFormularioBusca.Buscar}
        >
          <fieldset>
            <legend className="h3">Configurações</legend>

            <div className='col-xs-4'>
              <Label htmlFor="inputSemRestricao">Carregando: {loading ? 'sim': 'não'}</Label>
              <Button onClick={toggle}>Alterar para {carregandoLegenda(!loading)}</Button>
            </div>
          </fieldset>

          <fieldset>
            <legend className="h3">Input</legend>

            <div className="row">
              <div className='col-xs-4'>
                <Label htmlFor="inputSemRestricao">inputSemRestricao</Label>
                <Input name="inputSemRestricao" id="inputSemRestricao" type="text" placeholder="inputSemRestricao..." />
              </div>
              <div className='col-xs-4'>
                <Label htmlFor="inputHidden">inputHidden</Label>
                <Input name="inputHidden" id="inputHidden" type="text" placeholder="inputHidden..." />
              </div>
              <div className='col-xs-4'>
                <Label htmlFor="inputDisabled">inputDisabled</Label>
                <Input name="inputDisabled" id="inputDisabled" type="text" placeholder="inputDisabled..." />
              </div>
              <div className='col-xs-4'>
                <Label htmlFor="inputReadOnly">inputReadOnly</Label>
                <Input name="inputReadOnly" id="inputReadOnly" type="text" placeholder="inputReadOnly..." />
              </div>
              <div className='col-xs-4'>
                <Label htmlFor="inputReadOnlyVazio">inputReadOnlyVazio</Label>
                <Input name="inputReadOnlyVazio" id="inputReadOnlyVazio" type="text" placeholder="inputReadOnlyVazio..." />
              </div>
              <div className='col-xs-4'>
                <Label htmlFor="inputClearable">inputClearable</Label>
                <Input name="inputClearable" id="inputClearable" type="text" placeholder="inputClearable..." />
              </div>
            </div>
          </fieldset>

          <fieldset>
            <legend className="h3">Select</legend>

            <div className="row">
              <div className='col-xs-4'>
                <Label htmlFor="selectSemRestricao">selectSemRestricao</Label>
                <Select name="selectSemRestricao" inputId="selectSemRestricao" placeholder="selectSemRestricao..." options={opcoes} />
              </div>
              <div className='col-xs-4'>
                <Label htmlFor="selectHidden">selectHidden</Label>
                <Select name="selectHidden" inputId="selectHidden" placeholder="selectHidden..." options={opcoes} />
              </div>
              <div className='col-xs-4'>
                <Label htmlFor="selectDisabled">selectDisabled</Label>
                <Select name="selectDisabled" inputId="selectDisabled" placeholder="selectDisabled..." options={opcoes} />
              </div>
              <div className='col-xs-4'>
                <Label htmlFor="selectReadOnly">selectReadOnly</Label>
                <Select name="selectReadOnly" inputId="selectReadOnly" placeholder="selectReadOnly..." options={opcoes} />
              </div>
              <div className='col-xs-4'>
                <Label htmlFor="selectReadOnlyVazio">selectReadOnlyVazio</Label>
                <Select name="selectReadOnlyVazio" inputId="selectReadOnlyVazio" placeholder="selectReadOnlyVazio..." options={opcoes} />
              </div>
              <div className='col-xs-4'>
                <Label htmlFor="selectClearable">selectClearable</Label>
                <Select name="selectClearable" inputId="selectClearable" placeholder="selectClearable..." options={opcoes} />
              </div>
            </div>
          </fieldset>

          <fieldset>
            <legend className="h3">Select isMulti</legend>

            <div className="row">
              <div className='col-xs-4'>
                <Label htmlFor="selectMultiSemRestricao">selectMultiSemRestricao</Label>
                <Select name="selectMultiSemRestricao" inputId="selectMultiSemRestricao" placeholder="selectMultiSemRestricao..." options={opcoes} isMulti={true as any} />
              </div>
              <div className='col-xs-4'>
                <Label htmlFor="selectMultiHidden">selectMultiHidden</Label>
                <Select name="selectMultiHidden" inputId="selectMultiHidden" placeholder="selectMultiHidden..." options={opcoes} isMulti={true as any} />
              </div>
              <div className='col-xs-4'>
                <Label htmlFor="selectMultiDisabled">selectMultiDisabled</Label>
                <Select name="selectMultiDisabled" inputId="selectMultiDisabled" placeholder="selectMultiDisabled..." options={opcoes} isMulti={true as any} />
              </div>
              <div className='col-xs-4'>
                <Label htmlFor="selectMultiReadOnly">selectMultiReadOnly</Label>
                <Select name="selectMultiReadOnly" inputId="selectMultiReadOnly" placeholder="selectMultiReadOnly..." options={opcoes} isMulti={true as any} />
              </div>
              <div className='col-xs-4'>
                <Label htmlFor="selectMultiReadOnlyVazio">selectMultiReadOnlyVazio</Label>
                <Select name="selectMultiReadOnlyVazio" inputId="selectMultiReadOnlyVazio" placeholder="selectMultiReadOnlyVazio..." options={opcoes} isMulti={true as any} />
              </div>
              <div className='col-xs-4'>
                <Label htmlFor="selectMultiClearable">selectMultiClearable</Label>
                <Select name="selectMultiClearable" inputId="selectMultiClearable" placeholder="selectMultiClearable..." options={opcoes} isMulti={true as any} />
              </div>
            </div>
          </fieldset>

          <fieldset>
            <legend className="h3">Cascader</legend>

            <div className="row">
              <div className='col-xs-4'>
                <Label htmlFor="cascaderSemRestricao">cascaderSemRestricao</Label>
                <CascaderField name="cascaderSemRestricao" placeholder="cascaderSemRestricao..." floresta={floresta} />
              </div>
              <div className='col-xs-4'>
                <Label htmlFor="cascaderHidden">cascaderHidden</Label>
                <CascaderField name="cascaderHidden" placeholder="cascaderHidden..." floresta={floresta} />
              </div>
              <div className='col-xs-4'>
                <Label htmlFor="cascaderDisabled">cascaderDisabled</Label>
                <CascaderField name="cascaderDisabled" placeholder="cascaderDisabled..." floresta={floresta} />
              </div>
              <div className='col-xs-4'>
                <Label htmlFor="cascaderReadOnly">cascaderReadOnly</Label>
                <CascaderField name="cascaderReadOnly" placeholder="cascaderReadOnly..." floresta={floresta} />
              </div>
              <div className='col-xs-4'>
                <Label htmlFor="cascaderReadOnlyVazio">cascaderReadOnlyVazio</Label>
                <CascaderField name="cascaderReadOnlyVazio" placeholder="cascaderReadOnlyVazio..." floresta={floresta} />
              </div>
              <div className='col-xs-4'>
                <Label htmlFor="cascaderClearable">cascaderClearable</Label>
                <CascaderField name="cascaderClearable" placeholder="cascaderClearable..." floresta={floresta} />
              </div>
            </div>
          </fieldset>

          <fieldset>
            <legend className="h3">ServidorField</legend>

            <div className="row">
              <div className='col-xs-4'>
                <Label htmlFor="servidorSemRestricao">servidorSemRestricao</Label>
                <ServidorField name="servidorSemRestricao" placeholder="servidorSemRestricao..." floresta={floresta} />
              </div>
              <div className='col-xs-4'>
                <Label htmlFor="servidorHidden">servidorHidden</Label>
                <ServidorField name="servidorHidden" placeholder="servidorHidden..." floresta={floresta} />
              </div>
              <div className='col-xs-4'>
                <Label htmlFor="servidorDisabled">servidorDisabled</Label>
                <ServidorField name="servidorDisabled" placeholder="servidorDisabled..." floresta={floresta} />
              </div>
              <div className='col-xs-4'>
                <Label htmlFor="servidorReadOnly">servidorReadOnly</Label>
                <ServidorField name="servidorReadOnly" placeholder="servidorReadOnly..." floresta={floresta} />
              </div>
              <div className='col-xs-4'>
                <Label htmlFor="servidorReadOnlyVazio">servidorReadOnlyVazio</Label>
                <ServidorField name="servidorReadOnlyVazio" placeholder="servidorReadOnlyVazio..." floresta={floresta} />
              </div>
              <div className='col-xs-4'>
                <Label htmlFor="servidorClearable">servidorClearable</Label>
                <ServidorField name="servidorClearable" placeholder="servidorClearable..." floresta={floresta} />
              </div>
            </div>
          </fieldset>

          <fieldset>
            <legend className="h3">Editor</legend>

            <div className="row">
              <div className='col-xs-4'>
                <Label htmlFor="editorSemRestricao">editorSemRestricao</Label>
                <Editor name="editorSemRestricao" placeholder="editorSemRestricao..." />
              </div>
              <div className='col-xs-4'>
                <Label htmlFor="editorHidden">editorHidden</Label>
                <Editor name="editorHidden" placeholder="editorHidden..." />
              </div>
              <div className='col-xs-4'>
                <Label htmlFor="editorDisabled">editorDisabled</Label>
                <Editor name="editorDisabled" placeholder="editorDisabled..." />
              </div>
              <div className='col-xs-4'>
                <Label htmlFor="editorReadOnly">editorReadOnly</Label>
                <Editor name="editorReadOnly" placeholder="editorReadOnly..." />
              </div>
              <div className='col-xs-4'>
                <Label htmlFor="editorReadOnlyVazio">editorReadOnlyVazio</Label>
                <Editor name="editorReadOnlyVazio" placeholder="editorReadOnlyVazio..." />
              </div>
              <div className='col-xs-4'>
                <Label htmlFor="editorClearable">editorClearable</Label>
                <Editor name="editorClearable" placeholder="editorClearable..." />
              </div>
            </div>
          </fieldset>
          <FormikDebug />
        </Formulario>
      </Conteudo>
    </>
  )
}